import { render, staticRenderFns } from "./CheckInfo.vue?vue&type=template&id=fa344970&"
import script from "./CheckInfo.vue?vue&type=script&lang=js&"
export * from "./CheckInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports